import React from 'react';
import {Tag} from 'antd';
import PropTypes from 'prop-types';

import {UserOutlined} from '@/icons';

export default function UserTag({children, ...rest}) {
    return (
        <Tag color="blue" icon={<UserOutlined />} {...rest}>
            {children}
        </Tag>
    );
}

UserTag.propTypes = {
    children: PropTypes.node,
};
